import formatWFS from 'ol/format/WFS'
import Vue from 'vue'

export default {
  methods: {
    saveFeatures (n, m, r, layerName, clb, clbError) {
      let f = new formatWFS()
      let arr = layerName.split(':')
      let node = f.writeTransaction(n, m, r, {
        featureType: arr[1],
        featureNS: arr[0],
        srsName: 'EPSG:3857',
        gmlOptions: {srsName: 'EPSG:3857'}
      })

      let s = new XMLSerializer()
      let str = s.serializeToString(node)
      // str = str.replace(/geometry/g, 'geo')

      Vue.http.post('/api/gs/wfs', str, {
        headers: {
          'Content-Type': 'application/xml'
        }
      })
        .then(res => {
          let result = f.readTransactionResponse(res.body);
          if (result.transactionSummary) {
            clb && clb()
          } else {
            clbError && clbError(res)
          }
        }, res => {
          clbError && clbError(res)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/WFSEditorMixin.js